import { useEffect } from "react";
import { useSelector } from "react-redux";
import "./style.css";

const StripePricingTable = () => {
  const user = useSelector((state) => state.auth?.user);

  const pricingTableId = process.env.REACT_APP_PRICING_TABLE_ID;
  const publishableKey = process.env.REACT_APP_PUBLISHABLE_KEY;
  useEffect(() => {
    // Dynamically load Stripe script
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="subscription_container">
      <stripe-pricing-table
        pricing-table-id={pricingTableId}
        publishable-key={publishableKey}
        customer-email={user?.email}
        client-reference-id={
          user && user?.organization && user?.organization?.uuid
        }
      ></stripe-pricing-table>
    </div>
  );
};

export default StripePricingTable;
